import React, { useState, useEffect, useMemo } from "react";
import classnames from "classnames";
import { Link } from "react-router-dom";
import {
    Col, Row, Card, CardBody, Nav, NavItem, NavLink,
    TabContent, TabPane, Badge, Button, UncontrolledTooltip, Input, Spinner
} from "reactstrap";
import TableContainer from '../../../components/Common/TableContainer';
import Breadcrumbs from '../../../components/Common/Breadcrumb';

const UygunGeziler = () => {
    document.title = "Uygun Geziler | Partner Expedicar";

    const [activeTab, setActiveTab] = useState("1");
    
    // Aktif İlanlar (Tüm uygun geziler) State'leri
    const [tripsData, setTripsData] = useState([]);
    const [isLoadingTrips, setIsLoadingTrips] = useState(false);

    // Kullanıcının Teklifleri (Alıntılarım) State'leri
    const [quotesData, setQuotesData] = useState([]);
    const [isLoadingQuotes, setIsLoadingQuotes] = useState(false);

    const authUser = JSON.parse(localStorage.getItem("authUser"));
const userId = authUser?.ID;
const isAdmin = authUser?.Users_Type_ID === 3; // 3: Admin

    const toggleTab = (tab) => {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    };

useEffect(() => {
    const fetchAdverts = async () => {
        setIsLoadingTrips(true);
        try {
            // Admin her şeyi görür, sürücü sadece AKTİF olan VE KENDİSİNE ait olanları görür
            const filter = isAdmin 
                ? "" 
                : `$filter=Is_Active eq true and Users_ID eq ${userId}&`; 

            const response = await fetch(`https://hiflowapi.stechomeyazilim.info/Advert?${filter}$expand=Users_Car,Advert_Location`);
            const result = await response.json();

                if (result && result.value) {
                    const formattedData = result.value.map(item => {
                        const car = item.Users_Car || {};
                        const location = item.Advert_Location?.[0] || {}; 

                        return {
                            id: item.ID,
                            direction: item.Direction_Type || "", 
                            startCity: `${location.Start_City_Code || ''} ${location.Advert_Location_StartAddress?.split(',')[0] || ''}`, 
                            endCity: `${location.Finish_City_Code || ''} ${location.Advert_Location_FinishAddress?.split(',')[0] || ''}`, 
                            startDate: item.Advert_DateTime ? new Date(item.Advert_DateTime).toLocaleString('tr-TR') : "-",
                            endDate: item.Advert_DateTime2 ? new Date(item.Advert_DateTime2).toLocaleString('tr-TR') : "-",
                            customer: item.Customer_Notes || "Müşteri Bilgisi Yok",
                            carBody: car.Car_Body_Type || "-", 
                            engine: car.Engine_Type || "-",   
                            brand: car.Users_Car_Brand || "-",
                            model: car.Users_Car_Model || "-",
                            distance: location.Km ? `${location.Km} kilometre` : "-",
                            duration: item.Estimated_Duration || "-", 
                            quoteCount: "0-2", 
                            price: item.Price || 0,
                            priceType: "HİZMET" 
                        };
                    });
                    setTripsData(formattedData);
                }
            } catch (error) {
                console.error("İlanlar çekilirken hata oluştu:", error);
            } finally {
                setIsLoadingTrips(false);
            }
        };

        fetchAdverts();
    }, []);

 // 2. OData API'den TEKLİFLERİ Çekme İşlemi
useEffect(() => {
    const fetchMyQuotes = async () => {
        if (!userId) return;
        setIsLoadingQuotes(true);
        try {
            const quoteFilter = isAdmin ? "" : `$filter=Users_ID eq ${userId}`;
            // Sürücü bilgisini almak için $expand=Users ekledik
            const response = await fetch(`https://hiflowapi.stechomeyazilim.info/Advert_Offers?${quoteFilter}&$expand=Users`);
            const result = await response.json();

            if (result && result.value) {
                const formattedQuotes = result.value.map(item => ({
                    offerId: item.ID,
                    advertId: item.Advert_ID || "-",
                    date: item.Created_DateTime ? new Date(item.Created_DateTime).toLocaleDateString('tr-TR') : "-",
                    price: item.Price || item.Own_Offer || 0,
                    status: item.Offer_Status || "Bekliyor",
                    // Expand ile gelen kullanıcı adını buraya ekliyoruz
                    driverName: item.Users ? item.Users.Users_NameSurname : "Bilinmiyor"
                }));
                setQuotesData(formattedQuotes);
            }
        } catch (error) {
            console.error("Teklifler çekilirken hata:", error);
        } finally {
            setIsLoadingQuotes(false);
        }
    };
    fetchMyQuotes();
}, [isAdmin, userId]); // Bağımlılıklara dikkat



    // --- ANA TABLO KOLONLARI (Aktif İlanlar) ---
    const tripsColumns = useMemo(
        () => [
            {
                header: 'Kimlik Yolculuk',
                accessorKey: "id",
                enableSorting: true,
                cell: (cellProps) => <span className="text-body fw-bold">{cellProps.row.original.id}</span>
            },
            {
                header: 'ETİKETLER',
                accessorKey: "direction",
                enableSorting: false,
                cell: (cellProps) => {
                    const dir = cellProps.row.original.direction;
                    if (dir === "Git" || dir === "Gidiş") return <Badge className="bg-primary">Git</Badge>;
                    if (dir === "Dönüş") return <Badge className="bg-secondary">Dönüş</Badge>;
                    return null; 
                }
            },
            { header: 'Kalkış Şehri', accessorKey: "startCity", enableSorting: true },
            { header: 'Varış şehri', accessorKey: "endCity", enableSorting: true },
            { header: '...den', accessorKey: "startDate", enableSorting: true },
            { header: 'Kadar', accessorKey: "endDate", enableSorting: true },
            {
                header: 'Müşteri',
                accessorKey: "customer",
                enableSorting: true,
                cell: (cellProps) => <div style={{ maxWidth: "150px", whiteSpace: "normal" }}>{cellProps.row.original.customer}</div>
            },
            {
                header: 'Araç',
                accessorKey: "carBody",
                enableSorting: false,
                cell: (cellProps) => {
                    const row = cellProps.row.original;
                    const tooltipId = `carTooltip-${row.id}`;
                    return (
                        <>
                            <div id={tooltipId} style={{ cursor: "pointer", textDecoration: "underline dashed" }}>
                                {row.carBody} <br /> {row.engine}
                            </div>
                            <UncontrolledTooltip target={tooltipId} placement="top" className="custom-tooltip">
                                <div className="text-start">
                                    <strong>Marka:</strong> {row.brand}<br />
                                    <strong>Model:</strong> {row.model}<br />
                                    <strong>Motorizasyon:</strong> {row.engine}
                                </div>
                            </UncontrolledTooltip>
                        </>
                    )
                }
            },
            {
                header: 'Mesafe / Süre',
                accessorKey: "distance",
                enableSorting: true,
                cell: (cellProps) => (
                    <div>
                        {cellProps.row.original.distance} <br />
                        {cellProps.row.original.duration}
                    </div>
                )
            },
            {
                header: 'Fiyat',
                accessorKey: "price",
                enableSorting: true,
                cell: (cellProps) => {
                    const type = cellProps.row.original.priceType;
                    const priceStr = `~ €${cellProps.row.original.price} ${type}`;
                    return <Badge className={type === "TOPLAM" ? "bg-warning" : "bg-dark"} pill>{priceStr}</Badge>
                }
            },
            {
                header: 'Eylemler',
                enableSorting: false,
                cell: (cellProps) => {
                    const rowId = cellProps.row.original.id;
                    return (
                        <Link to={`/job-details/${rowId}`} className="btn btn-light btn-sm border-secondary text-dark outline">
                            Erişim
                        </Link>
                    );
                }
            },
        ],
        []
    );

    // --- ALINTILARIM TABLOSU KOLONLARI ---
const quotesColumns = useMemo(() => {
    // Önce herkes için ortak olan ilk kolonu koyuyoruz
    let baseColumns = [
        { 
            header: 'Kimlik Alıntı', 
            accessorKey: "offerId", 
            enableSorting: true, 
            cell: (cellProps) => <span className="fw-bold">{cellProps.row.original.offerId}</span> 
        }
    ];

    // EĞER ADMİN İSE: "Sürücü" kolonunu 2. sıraya (index 1) yerleştiriyoruz
    if (isAdmin) {
        baseColumns.push({
            header: 'Sürücü',
            accessorKey: "driverName",
            cell: (cellProps) => <span className="text-primary fw-medium">{cellProps.row.original.driverName}</span>
        });
    }

    // Geri kalan ortak kolonları sona ekliyoruz
    baseColumns = [
        ...baseColumns,
        { header: 'Kimlik Yolculuk', accessorKey: "advertId", enableSorting: true },
        { header: 'Tarih', accessorKey: "date", enableSorting: true },
        { header: 'Teklif', accessorKey: "price", enableSorting: true, cell: (cellProps) => <span>{cellProps.row.original.price} €</span> },
        {
            header: 'Durum',
            accessorKey: "status",
            cell: (cellProps) => {
                const status = cellProps.row.original.status.toLowerCase();
                let color = status.includes("kabul") ? "success" : status.includes("red") ? "danger" : "warning";
                return <Badge color={color}>{cellProps.row.original.status}</Badge>;
            }
        },
        {
            header: 'Eylemler',
            cell: (cellProps) => (
                <Link to={`/job-details/${cellProps.row.original.advertId}`} className="btn btn-light btn-sm border">
                    Göreve Git
                </Link>
            )
        }
    ];

    return baseColumns;
}, [isAdmin]); // isAdmin değiştiğinde tablo yapısı güncellenir


    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <Row className="mb-3">
                        <Col>
                            <h2 className="mb-3">Uygun geziler</h2>
                            <div className="alert alert-warning" role="alert">
                                <span className="badge bg-warning me-2">Yeni</span> 
                                Bazı görevler yeni bir özellik içerir: tekliflerin anında doğrulanması <Link to="#" className="alert-link text-warning text-decoration-underline">Daha Fazlasını Oku</Link>
                            </div>
                        </Col>
                        <Col className="text-end" md={3}>
                             <Button outline color="primary" size="sm">
                                <i className="mdi mdi-help-circle-outline me-1"></i> Bir görev nasıl aranır?
                             </Button>
                        </Col>
                    </Row>

                    <Row>
                        <Col lg="12">
                            <Card>
                                <CardBody className="pt-0 pb-0 border-bottom">
                                    <Nav tabs className="nav-tabs-custom nav-justified">
                                        <NavItem>
                                            <NavLink className={classnames({ active: activeTab === "1" })} onClick={() => toggleTab("1")} style={{ cursor: 'pointer' }}>
                                                Yakındaki geziler
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink className={classnames({ active: activeTab === "2" })} onClick={() => toggleTab("2")} style={{ cursor: 'pointer' }}>
                                                Tüm yolculuklar
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink className={classnames({ active: activeTab === "3" })} onClick={() => toggleTab("3")} style={{ cursor: 'pointer' }}>
                                                Daha fazla seyahate erişin
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink className={classnames({ active: activeTab === "4" })} onClick={() => toggleTab("4")} style={{ cursor: 'pointer' }}>
                                                Alıntılarım
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink className={classnames({ active: activeTab === "5" })} onClick={() => toggleTab("5")} style={{ cursor: 'pointer' }}>
                                                Yardım
                                            </NavLink>
                                        </NavItem>
                                    </Nav>
                                </CardBody>
                            </Card>

                            <TabContent activeTab={activeTab} className="p-3 bg-white mt-2">
                                
                                {/* SEKME 1: Yakındaki Geziler */}
                                <TabPane tabId="1">
                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                        <div className="text-muted">Size en yakın rotaların listesi Arama</div>
                                        <div>
                                            <Input type="text" placeholder="Anahtar kelime" style={{width: '250px', display: 'inline-block'}} className="form-control form-control-sm" />
                                            <Button color="light" size="sm" className="ms-1"><i className="mdi mdi-refresh"></i></Button>
                                        </div>
                                    </div>
                                    
                                    {isLoadingTrips ? (
                                        <div className="text-center py-5">
                                            <Spinner color="primary" /> <p className="mt-2">İlanlar yükleniyor...</p>
                                        </div>
                                    ) : (
                                        <TableContainer
                                            columns={tripsColumns}
                                            data={tripsData}
                                            isCustomPageSize={true}
                                            isPagination={true}
                                            tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline"
                                            paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                                        />
                                    )}
                                </TabPane>

                                {/* SEKME 2: Tüm Yolculuklar */}
                                <TabPane tabId="2">
                                     <Row className="mb-3">
                                        <Col md={3}>
                                            <label className="form-label text-muted">Kalkışta filtre</label>
                                            <Input type="select" className="form-select form-select-sm mb-1"><option>Bölüm numarası...</option></Input>
                                            <Input type="select" className="form-select form-select-sm"><option>Tüm bölgeler</option></Input>
                                        </Col>
                                        <Col md={3}>
                                            <label className="form-label text-muted">Varışta filtre</label>
                                            <Input type="select" className="form-select form-select-sm mb-1"><option>Bölüm numarası...</option></Input>
                                            <Input type="select" className="form-select form-select-sm"><option>Tüm bölgeler</option></Input>
                                        </Col>
                                     </Row>
                                     <TableContainer
                                        columns={tripsColumns}
                                        data={tripsData}
                                        isCustomPageSize={true}
                                        isPagination={true}
                                        tableClass="align-middle table-nowrap dt-responsive nowrap w-100"
                                    />
                                </TabPane>

                                {/* SEKME 3: QR Kod */}
                                <TabPane tabId="3">
                                    <div className="text-center bg-dark text-white rounded p-5 opacity-75 position-relative">
                                        <div className="position-absolute top-0 start-0 w-100 bg-success p-2 rounded-top">
                                             Mobil uygulamamıza erişin
                                        </div>
                                        <i className="mdi mdi-lock display-4 mt-4"></i>
                                        <h4 className="text-white mt-3">Daha fazla seyahate erişin</h4>
                                        <p>Sertifika gerektirenler de dahil olmak üzere tüm rotalarımıza erişmek için lütfen mobil uygulamaya bakın.</p>
                                        <div className="bg-white d-inline-block p-2 rounded mt-3">
                                            <i className="mdi mdi-qrcode-scan display-1 text-dark"></i>
                                        </div>
                                        <div className="mt-2">⬆️ Bu QR Kodunu tara 📸</div>
                                    </div>
                                </TabPane>

                                {/* SEKME 4: Alıntılarım (Kullanıcının Teklifleri) */}
                                <TabPane tabId="4">
                                     <p className="text-muted">Bu arama kriterleri için {quotesData.length} teklifiniz var.</p>
                                     
                                     {isLoadingQuotes ? (
                                        <div className="text-center py-5">
                                            <Spinner color="primary" /> <p className="mt-2">Teklifleriniz yükleniyor...</p>
                                        </div>
                                     ) : quotesData.length > 0 ? (
                                        <TableContainer
                                            columns={quotesColumns}
                                            data={quotesData}
                                            isCustomPageSize={true}
                                            isPagination={true}
                                            tableClass="align-middle table-nowrap dt-responsive nowrap w-100"
                                        />
                                     ) : (
                                         <div className="text-center text-muted py-5">
                                             Henüz bir teklifiniz bulunmuyor.
                                         </div>
                                     )}
                                </TabPane>

                                {/* SEKME 5: Yardım */}
                                <TabPane tabId="5">
                                    <h4>Sekme "Yakınlarda protracts"</h4>
                                    <p>Bu sekmede, kalkış veya varış adresinin evinize yakınlığına göre size sunabileceğimiz tüm rotaları bulacaksınız...</p>
                                    <h4 className="mt-4">"Benim tırnaklarım" (Alıntılarım) sekmesi</h4>
                                    <ul>
                                        <li><span className="text-warning">● Bekliyor:</span> teklif henüz ekiplerimiz tarafından incelenmedi.</li>
                                        <li><span className="text-success">● Kabul edildi:</span> görev size atandı.</li>
                                        <li><span className="text-danger">● Reddedildi:</span> görev size atanmadı.</li>
                                    </ul>
                                </TabPane>
                            </TabContent>
                        </Col>
                    </Row>
                </div>
            </div>
        </React.Fragment>
    );
}

export default UygunGeziler;